/* eslint-disable @scandipwa/scandipwa-guidelines/create-config-files */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { connect } from 'react-redux';

import ConfigQuery from 'Query/Config.query';
import { STORE_CONFIG_KEY } from 'SourceComponent/StoreSwitcher/StoreSwitcher.config';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps,
    StoreSwitcherContainer as SourceStoreSwitcherContainer
} from 'SourceComponent/StoreSwitcher/StoreSwitcher.container';
import { updateConfig } from 'Store/Config/Config.action';
import { isSignedIn } from 'Util/Auth';
import BrowserDatabase from 'Util/BrowserDatabase/BrowserDatabase';
import { setCurrency } from 'Util/Currency';
import { fetchMutation } from 'Util/Request';

import { DEFAULT_STORE_CURRENCY_CONFIG } from './StoreSwitcher.config';

/** @namespace Pwa/Component/StoreSwitcher/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    updateConfig: () => dispatch(updateConfig())
});

/** @namespace Pwa/Component/StoreSwitcher/Container */
export class StoreSwitcherContainer extends SourceStoreSwitcherContainer {
    async _updateCurrency(currencyCode, redirectUrl) {
        const { updateConfig } = this.props;

        await fetchMutation(ConfigQuery.getSaveSelectedCurrencyMutation(
            currencyCode
        )).then(
            /** @namespace Pwa/Component/StoreSwitcher/Container/StoreSwitcherContainer/_updateCurrency/fetchMutation/then */
            () => {
                setCurrency(currencyCode);
                updateConfig();
                window.location = redirectUrl;
            }
        );
    }

    _handleStoreSelect(storeCode) {
        const { showErrorNotification } = this.props;
        const { storeList } = this.state;

        const isSigned = isSignedIn();

        const store = storeList.find(
            ({ value }) => value === storeCode
        );

        if (!store) {
            showErrorNotification(__('This store can not be opened!'));
            return;
        }

        const storeCurrency = DEFAULT_STORE_CURRENCY_CONFIG[store.value]?.currency;
        BrowserDatabase.deleteItem(STORE_CONFIG_KEY);
        const baseUrl = `${ window.location.origin }/${ storeCode }/`;
        const baseUrlLength = baseUrl.length;
        const currentHref = window.location.href;
        const currentUrl = currentHref.substring(baseUrlLength);
        const redirectUrl = baseUrl + currentUrl;

        if (!isSigned) {
            this._updateCurrency(storeCurrency, redirectUrl);
        } else {
            window.location = redirectUrl;
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreSwitcherContainer);
